/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type { InsightConfigureRouteRedirect as ServicedeskCmdbConfigureType } from '@jira/spa-apps__servicedesk-cmdb-configure/src/InsightConfigureRouteRedirect.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbConfigure: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ServicedeskCmdbConfigureType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-configure", jiraSpaEntry: "async-servicedesk-cmdb-configure" */ '@jira/spa-apps__servicedesk-cmdb-configure/src/ServicedeskCmdbConfigure.tsx'
		),
);

const InsightConfigure = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbConfigure}
		pageId="spa-apps/servicedesk/insight/cmdb-configure"
		shouldShowSpinner
	/>
);

export default InsightConfigure;
